<!-- (c) TwistedMinds, Gerry Uytdenhouwen - 5 november 2026 -->
<template>
    <div class="account-tabs" role="tablist" :style="rootStyle">
        <button v-for="tab in tabs" :key="tab.key" type="button" role="tab"
                :aria-selected="value === tab.key ? 'true' : 'false'"
                :class="['account-tabs__tab', {'is-active': value === tab.key}]"
                @click="$emit('input', tab.key)">{{ $t(tab.label) }}</button>
    </div>
</template>

<script>
export default {
    props: {
        // Active tab key: 'orders' or 'profile'
        value: {type: String, default: 'orders'},
        theme: {type: Object, default: () => ({})},
    },
    data: () => ({
        tabs: [
            {key: 'orders', label: 'general.my-orders'},
            {key: 'profile', label: 'general.my-details'},
        ],
    }),
    computed: {
        rootStyle() {
            return {
                '--account-tabs-primary': (this.theme && this.theme.color) || '#1f2a2e',
                fontFamily: (this.theme && this.theme.fontFamily) || 'inherit',
            };
        },
    },
};
</script>

<style scoped lang="scss">
// Explicit colours and a full button reset: host stylesheets restyle button elements.
.account-tabs {
    display: flex;
    background: #fff;
    border-bottom: 1px solid #e8ecee;
    margin-bottom: 12px;

    &__tab {
        flex: 0 0 auto;
        margin: 0 0 -1px;
        padding: 10px 14px;
        background: none;
        border: 0;
        border-bottom: 2px solid transparent;
        border-radius: 0;
        box-shadow: none;
        font-family: inherit;
        font-size: 14px;
        font-weight: 600;
        line-height: normal;
        min-height: 0;
        text-transform: none;
        letter-spacing: normal;
        color: #6b7a80;
        cursor: pointer;

        &.is-active {
            color: var(--account-tabs-primary);
            border-bottom-color: var(--account-tabs-primary);
        }

        &:focus-visible {
            outline: 2px solid var(--account-tabs-primary);
            outline-offset: -2px;
        }
    }
}
</style>
